import { Box, Flex, Heading} from '@chakra-ui/react'
import React, { useContext } from 'react'
import { TokenContext, UserContext } from '../App'
import { baseUrl } from '../settings'
import Feed from '../Tweet/Feed'
import Navbar from '../Navbar/Navbar'

const Liked = () => {
    const {token, setToken} = useContext(TokenContext)
    const {user, setUser} = useContext(UserContext)

    console.log(user)
    
    return (
        <Flex>
            <Box>
                <Navbar></Navbar>
            </Box>
            <Box>
            <Heading>Tweets you liked</Heading>
            {token !==  "" || token === null? <Feed from_liked={true} url={`${baseUrl}/tweet/starred/${user.username}`}></Feed>: ""}
            </Box>
        </Flex>
    )
}

export default Liked